export type Ticket = {
  _id: string
  code: string
  title: string
  description: string
  createdAt: string
  status: TicketStatusEnum
}

export enum TicketStatusEnum {
  NEW = 'new',
  IN_PROGRESS = 'inProgress',
  CLOSED = 'closed',
  REFUSED = 'refused',
  CLIENT_CLOSED = 'clientClosed',
}
